// Here is a list of the toolbar
// Detail list see https://www.tinymce.com/docs/advanced/editor-control-identifiers/#toolbarcontrols

const toolbar = ['searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent  blockquote undo redo removeformat subscript superscript code paste codesample', 'hr bullist numlist anchor pagebreak forecolor backcolor fontsizeselect fontselect | link table media image wtImage preview fullscreen']

export default toolbar
